<template>
  <div id="app">
    <Breadcrumbs />
    <div class="container">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  components: {
    Breadcrumbs
  }
}
</script>

<style>
.container {
  max-width: 700px !important;
  padding-bottom: 100px;
}

p {
  font-size: 14px;
}

h1 {
  font-size: 38px !important;
  font-weight: 700 !important;
  line-height: 48px !important;
}

h2 {
  font-size: 28px !important;
  font-weight: 600 !important;
  line-height: 38px !important;
}

h3 {
  font-size: 24px !important;
  font-weight: 600 !important;
  line-height: 32px !important;
}

ul.links-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul.links-list > li {
  padding: 4px;
}

ul.links-list > li:hover {
  background: rgba(55, 53, 47, 0.08);
}

ul.links-list > li > a {
  font-size: 14px;
  color: rgb(55, 53, 47);
  font-weight: 500;
  line-height: 1.3;
  border-bottom: 1px solid rgba(55, 53, 47, 0.16);
}

ul.links-list > li > a:hover {
  color: rgb(55, 53, 47);
  text-decoration: none;
}

ul {
  font-size: 14px;
  padding-left: 25px;
}
ul li {
  padding: 3px 0;
}

.block {
  margin-top: 40px;
}

.section-icon {
  font-size: 70px;
}

.cta {
  color: #fff !important;
  text-transform: uppercase;
  text-decoration: none;
  background: #ed3e6b;
  padding: 20px;
  border-radius: 5px;
  display: inline-block;
  border: none;
  transition: all 0.4s ease 0s;
}

.cta:hover {
  background: #434343;
  letter-spacing: 1px;
  -webkit-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);
  -moz-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);
  box-shadow: 5px 40px -10px rgba(0, 0, 0, 0.57);
  transition: all 0.4s ease 0s;
}
</style>
